import { render, staticRenderFns } from "./TeamDetails.vue?vue&type=template&id=55b5663e&scoped=true"
import script from "./TeamDetails.vue?vue&type=script&lang=js"
export * from "./TeamDetails.vue?vue&type=script&lang=js"
import style0 from "./TeamDetails.vue?vue&type=style&index=0&id=55b5663e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b5663e",
  null
  
)

export default component.exports